import { Turnstile } from "@marsidev/react-turnstile";
import { useEffect, useState } from "react";

import { useCaptcha } from "@smart/bridge-captcha-dom";

import { Toast } from "../../types";

export const CaptchaChallenge = ({
  setToasts,
}: {
  setToasts?: (toasts: Toast[]) => void;
}) => {
  const [shouldShow, setShouldShow] = useState(false);
  const captchaContext = useCaptcha();

  useEffect(() => {
    if (
      captchaContext &&
      captchaContext.isInitialised &&
      !captchaContext.token
    ) {
      setShouldShow(true);
    }
  }, [captchaContext?.isInitialised]);

  if (!shouldShow) return null;

  return (
    <div className="mb-[4.5rem]" data-testid="captcha-challenge">
      <Turnstile
        id="captcha-challenge"
        siteKey={captchaContext?.siteKey || ""}
        onSuccess={(generatedToken) => {
          captchaContext?.setToken(generatedToken);
        }}
        onError={() => {
          setToasts?.([
            {
              text: "Failed to verify you are human, please refresh the page and try again.",
              palette: "destructive",
            },
          ]);
        }}
      />
    </div>
  );
};
